import React from 'react';
import PropTypes from 'prop-types';

import {
    Abstrap,
    Icon,
} from '..';

const propTypes = {
    ...Abstrap.propTypes,
    icon: PropTypes.string.isRequired,
    delay: PropTypes.number,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'span',
    delay: 10 * 1000,
};

class IconLoader extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            's-icon-loader',
            className,
        ];
    }

    getIterationCount() {
        const { delay } = this.props;
        if (delay < 0) {
            return 'infinite';
        }
        return 1;
    }

    renderChildren() {
        const { icon, delay } = this.props;
        return (
            <>
                <span className="s-icon-loader__left">
                    <span
                        className="s-icon-loader__animation"
                        style={{
                            cursor: 'pointer',
                            animationDelay: '0s',
                            animationDuration: `${(delay < 0 ? 3 : delay * 2)}s`,
                            animationIterationCount: this.getIterationCount(),
                        }}
                    />
                </span>
                <Icon icon={icon} />
                <span className="s-icon-loader__right">
                    <span
                        className="s-icon-loader__animation"
                        style={{
                            cursor: 'pointer',
                            animationDelay: `${delay < 0 ? 3 : delay / 2}s`,
                            animationDuration: `${(delay < 0 ? 3 : delay * 2)}s`,
                            animationIterationCount: this.getIterationCount(),
                        }}
                    />
                </span>
            </>
        );
    }

}

IconLoader.propTypes = propTypes;

IconLoader.defaultProps = defaultProps;

export default IconLoader;
